/* eslint-disable @typescript-eslint/no-shadow */
import '../styles/global.css';

import { GoogleTagManager } from '@next/third-parties/google';
import localFont from 'next/font/local';

import { RealViewport } from '@/components/core/RealViewport';
import PreviewNotification from '@/components/elements/PreviewCopy';
import TopographicalMap from '@/components/elements/TopoMap/TopographicalMap';

const fontMilliard = localFont({
  src: [
    // {
    //   style: 'normal',
    //   weight: '100',
    //   path: '../assets/Milliard/MilliardHairline.otf',
    // },
    // {
    //   style: 'italic',
    //   weight: '100',
    //   path: '../assets/Milliard/MilliardHairlineItalic.otf',
    // },
    // {
    //   style: 'normal',
    //   weight: '150',
    //   path: '../assets/Milliard/MilliardThin.otf',
    // },
    // {
    //   style: 'italic',
    //   weight: '150',
    //   path: '../assets/Milliard/MilliardThinItalic.otf',
    // },
    {
      style: 'normal',
      weight: '200',
      path: '../assets/Milliard/MilliardExtraLight.otf',
    },
    // {
    //   style: 'italic',
    //   weight: '200',
    //   path: '../assets/Milliard/MilliardExtraLightItalic.otf',
    // },
    {
      style: 'normal',
      weight: '300',
      path: '../assets/Milliard/MilliardLight.otf',
    },
    // {
    //   style: 'italic',
    //   weight: '300',
    //   path: '../assets/Milliard/MilliardLightItalic.otf',
    // },
    {
      style: 'normal',
      weight: '400',
      path: '../assets/Milliard/MilliardBook.otf',
    },
    {
      style: 'italic',
      weight: '400',
      path: '../assets/Milliard/MilliardBookItalic.otf',
    },
    {
      style: 'normal',
      weight: '500',
      path: '../assets/Milliard/MilliardMedium.otf',
    },
    // {
    //   style: 'italic',
    //   weight: '500',
    //   path: '../assets/Milliard/MilliardMediumItalic.otf',
    // },
    {
      style: 'normal',
      weight: '600',
      path: '../assets/Milliard/MilliardSemiBold.otf',
    },
    // {
    //   style: 'italic',
    //   weight: '600',
    //   path: '../assets/Milliard/MilliardSemiBoldItalic.otf',
    // },
    {
      style: 'normal',
      weight: '700',
      path: '../assets/Milliard/MilliardBold.otf',
    },
    // {
    //   style: 'italic',
    //   weight: '700',
    //   path: '../assets/Milliard/MilliardBoldItalic.otf',
    // },
    // {
    //   style: 'normal',
    //   weight: '800',
    //   path: '../assets/Milliard/MilliardExtraBold.otf',
    // },
    // {
    //   style: 'italic',
    //   weight: '800',
    //   path: '../assets/Milliard/MilliardExtraBoldItalic.otf',
    // },
    // {
    //   style: 'normal',
    //   weight: '850',
    //   path: '../assets/Milliard/MilliardHeavy.otf',
    // },
    // {
    //   style: 'italic',
    //   weight: '850',
    //   path: '../assets/Milliard/MilliardHeavyItalic.otf',
    // },
    {
      style: 'normal',
      weight: '900',
      path: '../assets/Milliard/MilliardBlack.otf',
    },
    // {
    //   style: 'italic',
    //   weight: '900',
    //   path: '../assets/Milliard/MilliardBlackItalic.otf',
    // },
  ],
  variable: '--font-milliard',
});

function MyApp({ Component, pageProps, router }) {
  return (
    <>
      <div className={`${fontMilliard.variable} overflow-x-clip font-sans`}>
        <RealViewport />
        <Component {...pageProps} key="root" />
        <TopographicalMap />
        {router.state?.isPreview && <PreviewNotification />}
        <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM_ID} />
      </div>
    </>
  );
}

export default MyApp;
